<template>
    <div class="content_div">
        <el-row :gutter="10">
            <el-col :span="5">
                <el-card>
                    <el-tree :default-expand-all="true" :data="deptData" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
                </el-card>
            </el-col>
            <el-col :span="19">
                <el-card>
                    <!--商品-->
                    <el-form :inline="true" :model="query" class="demo-form-inline" style="margin-bottom: 20px;">
                        <el-form-item label="登陆名">
                            <el-input clearable class="input_class" v-model="query.username" auto-complete="off"
                                      placeholder="请输入登陆名"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号">
                            <el-input clearable class="input_class" v-model="query.phone" auto-complete="off"
                                      placeholder="请输入手机号"></el-input>
                        </el-form-item>
                        <el-form-item label="昵称">
                            <el-input clearable class="input_class" v-model="query.nickname" auto-complete="off" placeholder="请输入昵称"></el-input>
                        </el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
                        <el-button type="success" @click="btnInsert(null,0)">新增</el-button>
                    </el-form>

                    <el-table
                        :data="list"
                        border>
                        <el-table-column type="index" label="编号" width="80"/>
                        <el-table-column prop="deptName" label="所属部门"/>
                        <el-table-column prop="username" label="登录名"/>
                        <el-table-column prop="phone" label="手机号"/>
                        <el-table-column prop="nickname" label="昵称"/>
                        <el-table-column prop="createTime" label="注册时间"/>
                        <el-table-column align="center" label="操作" width="150">
                            <template slot-scope="scope">
                                <el-button type="text" @click="btnInsert(scope.row,2)">修改</el-button>
                                <el-dropdown size="small" @command="(command) => handleCommand(command, scope.row)" style="margin-left: 10px;">
                                    <el-button size="small" type="text" icon="el-icon-d-arrow-right">更多</el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="handleResetPassword" icon="el-icon-refresh-left">重置密码</el-dropdown-item>
                                        <el-dropdown-item command="handleAuthUser" icon="el-icon-s-custom">分配角色</el-dropdown-item>
                                        <el-dropdown-item command="handlerCater" icon="el-icon-s-cooperation">点餐配置</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination style="margin-top:10px;"
                                   background
                                   layout="total,prev, pager, next"
                                   @current-change="currentChange"
                                   :total="total">
                    </el-pagination>
                </el-card>
            </el-col>
        </el-row>

        <el-dialog :close-on-click-modal="false" title="操作" :visible="isShowDialogFlag" @close="close" width="30%">
            <el-form label-width="120px" :model="data" ref="data" :rules="rules">
                <el-form-item label="登陆名" prop="username">
                    <el-input maxLength="20" v-model="data.username" maxlength="20" auto-complete="off"
                              placeholder="请输入登陆名"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input maxlength="11" v-model="data.phone" auto-complete="off" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="nickname">
                    <el-input maxlength="20" v-model="data.nickname" auto-complete="off" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <!-- 添加部门选择 -->

                <!-- 替换 el-tree-select 部分 -->
                <el-form-item label="所属部门" prop="deptId">
                    <el-popover
                        ref="deptPopover"
                        placement="bottom-start"
                        trigger="click"
                        width="300">
                        <el-tree
                            :data="addDeptData"
                            :props="defaultProps"
                            node-key="id"
                            @node-click="handleDeptSelect">
                        </el-tree>
                        <el-input
                            slot="reference"
                            v-model="data.deptName"
                            readonly
                            placeholder="请选择部门"
                            suffix-icon="el-icon-arrow-down">
                        </el-input>
                    </el-popover>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click='close'>取消</el-button>
                <el-button type="primary" class="title" @click="submitForm('data')">保存</el-button>
            </div>
        </el-dialog>

        <!-- 角色分配对话框 -->
        <el-dialog :close-on-click-modal="false" title="分配角色" :visible="roleDialogVisible" @close="closeRoleDialog" width="40%">
            <el-form :model="authParams" ref="roleForm" label-width="100px">
                <el-form-item label="用户">
                    <el-input v-model="authParams.nickname" readonly></el-input>
                </el-form-item>
                <el-form-item label="角色列表" prop="roleIdList">
                    <el-select v-model="authParams.roleIdList" multiple placeholder="请选择" style="width: 80%">
                        <el-option
                            v-for="item in roleList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">{{ item.name }}
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeRoleDialog">取消</el-button>
                <el-button type="primary" @click="submitRoleForm">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="点餐配置" :visible="caterDialogVisible" @close="closeCaterDialog" width="40%">
            <el-form :model="caterParams" ref="roleForm" label-width="100px">
                <el-form-item label="用户">
                    <el-input v-model="caterParams.nickname" disabled></el-input>
                </el-form-item>
                <el-form-item label="可点餐" prop="businessType">
                    <el-select v-model="caterParams.businessType" placeholder="请选择" style="width: 80%">
                        <!--可点餐：默认1员工餐；2客户餐；3员工和客户餐-->
                        <el-option label="员工餐" :value="1"></el-option>
                        <el-option label="客户餐" :value="2"></el-option>
                        <el-option label="员工和客户餐" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <!--点餐数量-->
                <el-form-item label="点餐数量" prop="maxCount">
                    <el-input-number v-model="caterParams.maxCount" :min="1" :max="99" label="请输入点餐数量"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeCaterDialog">取消</el-button>
                <el-button type="primary" @click="submitRoleForm2">保存</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import {reqListDept} from "../../../api/core/Dept";
import {reqAuthRoleByUserId, reqListUsers} from "../../../api/core/Users";
import {reqInsertSysUsers, reqUpdateSysUsers} from "../../../api/core/Person";
import {reqUpdateBaseInfo, resetPassword} from "../../../api/user";
import {listRoles} from "../../../api/system/role";
import menuItem from "../../../layout/SideBar/MenuItem.vue";

export default {
    name: "Users",
    async created() {
        await this.loadDept();
        await this.load();
    },
    methods: {
        async loadDept() {
            let data = await reqListDept({});
            this.deptData = data;
            this.addDeptData = JSON.parse(JSON.stringify(data))
        },
        async load() {
            this.list = [];
            let data = await reqListUsers(this.query);
            this.list = data.records;
            this.total = data.total;
        },
        currentChange(num) {
            this.query.currentPage = num;
            this.load();
        },
        async handleNodeClick(data) {
            console.log(data.id);
            this.query.deptId = data.id;
            await this.load();
        },
        btnInsert(row, type) {
            if (type === 0) {
                this.data = {
                    id: null,
                    deptId: null,
                    deptName: null,
                    username: '',
                    phone: '',
                    nickname: ''
                };
            } else if (type === 1) {
                this.data = {
                    id: null,
                    deptId: null,
                    deptName: null,
                    username: '',
                    phone: '',
                    nickname: ''
                };
            } else {
                this.data = JSON.parse(JSON.stringify(row));
            }
            this.isShowDialogFlag = true;
        },
        async close() {
            this.isShowDialogFlag = false;
        },
        handleDeptSelect(node) {
            this.data.deptId = node.id;
            this.data.deptName = node.name;
            this.$refs.deptPopover.doClose();
        },
        async submitForm(formName) {
            this.$refs[formName].validate(async valid => {
                if (valid) {
                    this.data.type = 0;
                    let result = !this.data.id ? await reqInsertSysUsers(this.data) : await reqUpdateSysUsers(this.data);
                    this.$message.success("操作成功");
                    await this.close();
                    await this.load();
                }
            })
        },
        handleCommand(command, row) {
            switch (command) {
                case 'handleResetPassword':
                    this.handleResetPassword(row)
                    break
                case 'handleAuthUser':
                    this.handleAuthUser(row)
                    break
                case 'handlerCater':
                    this.handleCater(row);
                    break;
                default:
                    break
            }
        },
        handleResetPassword(row) {
            const that = this
            this.$confirm('是否重置用户 ' + row.nickname + ' 的密码？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 执行重置用户密码方法
                resetPassword(row.id).then((res) => {
                    that.$message.success('密码重置成功')
                })
            }).catch(() => {
            })
        },
        /**
         * 分配角色处理方法
         */
        async handleAuthUser(row) {
            // 加载角色列表
            await this.loadRoleList();
            //从row.roles中获取角色ID列表
            this.authParams.roleIdList = [];
            if (row.roles) {
                for (let i = 0; i < row.roles.length; i++) {
                    this.authParams.roleIdList.push(row.roles[i].id);
                }
            }
            this.authParams.userId = row.id;
            this.authParams.nickname = row.nickname;
            // 显示角色分配对话框
            this.roleDialogVisible = true;
        },
        async handleCater(row) {
            //下拉选择
            this.caterParams.businessType = row.businessType;
            this.caterParams.id = row.id;
            this.caterParams.nickname = row.nickname;
            this.caterParams.maxCount = row.maxCount;
            this.caterDialogVisible = true;
        },
        async loadRoleList() {
            let data = await listRoles({currentPage: 1, pageSize: 1000});
            //去除掉data.list中id为1的数据
            data.list = data.list.filter(item => item.id !== 1);
            this.roleList = data.list;
        },
        /**
         * 提交角色分配表单
         */
        async submitRoleForm() {
            if (this.authParams.roleIdList.length === 0) {
                this.$message.error("请选择角色");
                return;
            }
            await reqAuthRoleByUserId(this.authParams);
            this.$message.success("角色分配成功");
            this.closeRoleDialog();
        },
        /**
         * 关闭角色分配对话框
         */
        closeRoleDialog() {
            this.roleDialogVisible = false;
            this.authParams = {
                userId: null,
                nickname: '',
                roleIdList: []
            };
            this.roleList = [];
        },
        closeCaterDialog() {
            this.caterDialogVisible = false;
        },
        async submitRoleForm2() {
            if (!this.caterParams.businessType) {
                this.$message.error("请选择可点餐配置！");
                return;
            }
            await reqUpdateBaseInfo(this.caterParams);
            this.$message.success("可点餐配置成功");
            this.closeCaterDialog();
            await this.load();
        }
    },
    data() {
        return {
            deptData: [],
            addDeptData: [],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            list: [],
            total: 0,
            query: {
                currentPage: 1,
                pageSize: 10,
                type: 0,
            },
            isShowDialogFlag: false,
            data: {
                id: null,
                deptId: null,
                deptName: null,
            },
            rules: {
                username: [
                    {required: true, message: '请输入登陆名', trigger: 'blur'}
                ],
                phone: [
                    {required: true, message: '请输入手机号', trigger: 'blur'}
                ],
                nickname: [
                    {required: true, message: '请输入姓名', trigger: 'blur'}
                ],
                deptId: [
                    {required: true, message: '请选择部门', trigger: 'change'}
                ]
            },
            roleDialogVisible: false,
            roleList: [],
            authParams: {
                userId: null, roleIdList: [],
                nickname: null,
            },
            caterDialogVisible: false,
            caterParams: {
                id: null,
                nickname: null,
                businessType: null,
                maxCount: null,
            },
        }
    }
}
</script>
<style scoped>
</style>
